export const RESET = 'TESTIMONIAL_LIST_RESET';
export const SET_ITEMS = 'TESTIMONIAL_LIST_SET_ITEMS';
export const SET_ERROR = 'TESTIMONIAL_LIST_SET_ERROR';
export const SET_SELECT_ITEMS = 'TESTIMONIAL_LIST_SET_SELECT_ITEMS';
export const SET_VIEW = 'TESTIMONIAL_LIST_SET_VIEW';
export const TOGGLE_LOADING = 'TESTIMONIAL_LIST_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/testimonial/list/mutation_types.js